module.exports = __webpack_public_path__ + "media/images/okra-offers/rewards-buy-1-get-1-43910c429cecbef40c1f2e7e7b1dc33f.png";